import { AccountDto, AmlProvider, InvoiceDto, PlanTemplateDto, UserPlan } from "../../api/models/fraud.models";

export function getPriceRange(prices: (number | undefined)[], type?: 'max' | 'min'): string {
  const validPrices = prices.filter((price): price is number => typeof price === 'number');

  if (!validPrices.length) {
    return '0.00 - 0.00';
  }

  const minPrice = Math.min(...validPrices);
  const maxPrice = Math.max(...validPrices);

  switch (type) {
    case 'min':
      return `${minPrice.toFixed(2)}`;
    case 'max':
      return `${maxPrice.toFixed(2)}`;
  }

  if (minPrice === maxPrice) {
    return `${minPrice.toFixed(2)}`;
  }

  return `${minPrice.toFixed(2)} - ${maxPrice.toFixed(2)}`;
}

export function groupCostProviders(plan: PlanTemplateDto | UserPlan): number[] {
  const providerPrices: { provider: AmlProvider; price: number | null }[] = [
    { provider: 'SECRET_SAUCE', price: plan.secretSaucePrice },
    { provider: 'GLOBAL_LEDGER', price: plan.globalLedgerPrice },
    { provider: 'BEOSIN', price: plan.beosinPrice },
    { provider: 'BITOK', price: plan.bitokPrice },
  ];

  return providerPrices
    .filter(({ provider }) => plan.enabledProviders.includes(provider))
    .map(({ price }) => price)
    .filter((price): price is number => price !== null);
}

export function  isValidPrice(price: unknown): price is number {
  return typeof price === 'number' && Number.isFinite(price);
}

export function getPendingUpgradeInvoice(account: AccountDto | null | undefined): InvoiceDto | null {
  if (!account) {
    return null;
  }

  const pendingInvoice = account.accountType === 'CORPORATE'
    ? account.companyDto?.pendingPlanUpgradeInvoice
    : account.pendingPlanUpgradeInvoice;

  return pendingInvoice?? null;
}
